import FormFieldCheck from "@/store/requestFormFieldCheck";

// const defaultFormAlfaTest = () => {
//   return {
//     lastName: "тест",
//     firstName: "тест",
//     middleName: "тест",
//     passport: {
//       birthDate: "1990-01-01",
//       birthPlace: "г Москва, пр-кт Защитников Москвы, д 5",
//       series: '7878',
//       oldSeries: '',
//       oldNumber: '',
//       number: '777887',
//       issueDate: "2010-01-01",
//       officeCode: "789-678",
//       office: "Москва"
//     },
//     mobilePhone: '+7 (925) 754-08-85',
//     sex: "",
//     workInfo: {
//       income: '500000'
//     },
//     code911: "DEFAULT",
//     residentialAddress: {},
//     residentialAddressUnrestricted_value: 'г Москва, пр-кт Защитников Москвы, д 5',
//     registrationAddress: {},
//     registrationAddressUnrestricted_value: 'г Москва, пр-кт Защитников Москвы, д 5',
//     identicalAddresses:false,
//     confCode:'',
//     selfDelivery:true,
//     RouteCode:null,
//     resultAlfaCheckAddress:{},
//     AlfaCard_Newdemand:{},
//     AlfaCard_FormSaved:{},
//   }
// };

const defaultFormAlfa = () => {
  return {
    lastName: "",
    firstName: "",
    middleName: "",
    passport: {
      birthDate: "",
      birthPlace: "",
      series: '',
      oldSeries: '',
      oldNumber: '',
      number: '',
      issueDate: "",
      officeCode: "",
      office: ""
    },
    mobilePhone: '',
    sex: "",
    workInfo: {
      income: ''
    },
    code911: "DEFAULT",
    residentialAddress: {},
    residentialAddressUnrestricted_value: '',
    registrationAddress: {},
    registrationAddressUnrestricted_value: '',
    identicalAddresses:false,
    confCode:'',
    selfDelivery:true,
    RouteCode:null,
    resultAlfaCheckAddress:{
      RCID:'',
      RPID:'',
      ZOID:'',
    },
    AlfaCard_Newdemand:{},
    AlfaCard_FormSaved:{},
  }
};

const defAlfaCheckState = () => {
  return {
    lastName: {code: 1, msg: 'обязательное поле', ShowError: false},
    firstName: {code: 1, msg: 'обязательное поле', ShowError: false},
    middleName: {code: 1, msg: 'обязательное поле', ShowError: false},
    passport: {
      birthDate: {code: 1, msg: 'обязательное поле', ShowError: false},
      birthPlace: {code: 1, msg: 'обязательное поле', ShowError: false},
      series: {code: 1, msg: 'обязательное поле', ShowError: false},
      oldSeries: {code: 0, msg: '', ShowError: false},
      oldNumber: {code: 0, msg: '', ShowError: false},
      number: {code: 1, msg: 'обязательное поле', ShowError: false},
      issueDate: {code: 1, msg: 'обязательное поле', ShowError: false},
      officeCode: {code: 1, msg: 'обязательное поле', ShowError: false},
      office: {code: 1, msg: 'обязательное поле', ShowError: false}
    },
    mobilePhone: {code: 1, msg: 'обязательное поле', ShowError: false},
    sex: {code: 1, msg: 'обязательное поле', ShowError: false},
    workInfo: {
      income: {code: 1, msg: 'обязательное поле', ShowError: false}
    },
    code911: {code: 0, msg: '', ShowError: false},
    residentialAddress: {code: 0, msg: '', ShowError: false},
    residentialAddressUnrestricted_value: {code: 1, msg: 'обязательное поле', ShowError: false},
    registrationAddress: {code: 0, msg: '', ShowError: false},
    registrationAddressUnrestricted_value: {code: 1, msg: 'обязательное поле', ShowError: false},
    confCode: {code: 1, msg:'обязательное поле', ShowError: false},
    selfDelivery:{code: 0, msg:'', ShowError: false},
    resultAlfaCheckAddress:{code: 0, msg:'', ShowError: false},
    AlfaCard_Newdemand:{code: 0, msg:'', ShowError: false},
    AlfaCard_FormSaved:{code: 0, msg:'', ShowError: false},
    identicalAddresses:{code: 0, msg:'', ShowError: false},
  }
};

const state ={
  alfaForm: defaultFormAlfa(),
  checkResult:defAlfaCheckState(),
  stepForm: 0,
  session:0,
  AdditionalInfo:{},
};

const getters ={
  isAlfaAdressValid: (state) => (target) => {
    if (state.alfaForm[target].value === undefined || state.alfaForm[target].value.length === 0) {
      return 'Обязательное поле, Вы должны выбрать адрес из выпадающего списка';
    }
    if (state.alfaForm[target].value !== undefined && state.alfaForm[target].value !== state.alfaForm[target+'Unrestricted_value']) {
      return 'Вы должны выбрать адрес из выпадающего списка';
    }
    try {
      if (state.alfaForm[target].data.house == null) {
        return 'Адрес не полный, укажите город, улицу и номер дома';
      }
    } catch (e) {
      return 'Адрес не корректный';
    }
    return '';
  },
};

const actions ={
  alfaSetAddressError:({commit},newObj)=>{
    commit('showStatusAlfa',{
      key:newObj.key + 'Unrestricted_value',
      value:newObj.show,
      parent:'',
    });
    commit('setStateCheckAlfaRoot',{
      formKey:newObj.key + 'Unrestricted_value',
      status:{
        code:newObj.code,
        msg:newObj.msg
      },
    });
  },
  chekField: ({commit}, newObj) => {
    newObj['status'] = (typeof FormFieldCheck[newObj.formKey] == 'function')?
      FormFieldCheck[newObj.formKey](newObj.value) :
      FormFieldCheck.isEmpty(newObj.value);
    if (newObj.parent.length > 0) {
      commit('setStateCheckAlfaChildren',newObj);
    } else {
      commit('setStateCheckAlfaRoot',newObj);
    }
  },
  updateAlfaFormValue: ({commit, dispatch}, newObj) => {
    if (newObj != undefined
      && newObj.formKey != undefined
      && newObj.parent != undefined
      && newObj.value != undefined) {
      if (newObj.parent.length > 0) {
        commit('setStateAlfaChildren', {
          parent: newObj.parent,
          formKey: newObj.formKey,
          value: newObj.value
        });
        dispatch('chekField',{
          parent: newObj.parent,
          formKey: newObj.formKey,
          value: newObj.value
        });
      } else {
        if (state.alfaForm[newObj.formKey] != undefined && state.alfaForm[newObj.formKey] != newObj.value) {
          commit('setStateAlfaRoot', {
            formKey: newObj.formKey,
            value: newObj.value
          });
          dispatch('chekField',{
            formKey: newObj.formKey,
            value: newObj.value,
            parent: ''
          });
        }
      }
    } else {
      alert('updateAlfaFormValue newObj undefined');
    }
  },
  errorShow: ({commit}, valueObj) => {
    if (valueObj != undefined
      && valueObj.formKey != undefined
      && valueObj.parent != undefined){
        commit('saveErrorShow', valueObj);

      }

  },
  AdditionalInfoAdd:({commit}, valueObj) =>{
    if (valueObj != undefined && typeof valueObj == 'object') {
      commit('setAdditionalInfo',valueObj);
    }
  },
  addSession:({commit},session)=>{
    if (typeof session == 'number' && session > 0){
      commit('setSession',session);
    }
  }
};
const mutations ={
  resetStateAlfaForm:(state)=>{
    Object.assign(state.alfaForm, defaultFormAlfa());
  },
  setStateAlfaRoot: (state, newVal) => state.alfaForm[newVal.formKey] = newVal.value,
  setStateAlfaChildren: (state, newVal) => state.alfaForm[newVal.parent][newVal.formKey] = newVal.value,
  setStateCheckAlfaRoot: (state, newVal) => {
    state.checkResult[newVal.formKey].code = newVal.status.code;
    state.checkResult[newVal.formKey].msg = newVal.status.msg;
  },
  setStateCheckAlfaChildren: (state, newVal) =>{
    state.checkResult[newVal.parent][newVal.formKey].code = newVal.status.code;
    state.checkResult[newVal.parent][newVal.formKey].msg = newVal.status.msg;
  },
  incStepForm:(state)=> state.stepForm += 1,
  showStatusChildAlfa:(state, newVal)=>{
    state.checkResult[newVal.parent][newVal.key].ShowError = newVal.value;
  },
  showStatusAlfa:(state, newVal)=>{
    state.checkResult[newVal.key].ShowError = newVal.value;
  },
  formFalse:(state)=>{state.stepForm = -1},
  saveErrorShow:(state, newVal)=>{state.checkResult[newVal.parent][newVal.formKey].ShowError = true},
  setAdditionalInfo:(state, newVal)=>{state.AdditionalInfo = newVal},
  setSession:(state,session) => state.session = session,
};

export default {
  state,
  mutations,
  getters,
  actions
}
